"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const style_overider_1 = __importDefault(require("utils/style-overider"));
const card_style_1 = __importDefault(require("./card.style"));
const CardBody = ({ children, style, id, className }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: id, className: className, style: (0, style_overider_1.default)(card_style_1.default.cardBodyRoot, style) }, { children: children })));
};
exports.default = CardBody;
